import { useCallback } from 'react';

import { useTracking } from '@change-corgi/core-react/tracking';

import { useCurrentRouteConfig } from '#src/app/routes';
import { useLocale } from '#src/app/shared/hooks/l10n';

import { LOCALES_FOR_SAP_LINK } from '../../../../../../shared/consts';

const ROUTE_IDS_WITHOUT_SAP_BUTTON: ReadonlySet<string> = new Set([
	'start-a-petition-v2',
	'ambassador-draft',
	'ambassador-start',
]);

type Result = ModelHookResult<
	{ isSpecialLocale: boolean; hidesSapButton: boolean; sapLink: string },
	{ trackSapNavigation: (type: 'button' | 'link') => void }
>;

export function useSAPButton(): Result {
	const track = useTracking();
	const currentLocale = useLocale();
	const isSpecialLocale = LOCALES_FOR_SAP_LINK.has(currentLocale);

	const currentRoute = useCurrentRouteConfig();
	const routeId = currentRoute?.config.id;
	const hidesSapButton = !!routeId && ROUTE_IDS_WITHOUT_SAP_BUTTON.has(routeId);

	return {
		data: {
			isSpecialLocale,
			hidesSapButton,
			sapLink: '/start-a-petition/intro?source_location=header',
		},
		actions: {
			trackSapNavigation: useCallback(
				(type) => {
					void track('nav_sap_click', {
						link_type: type,
						route_id: routeId ?? 'unknown',
					});
				},
				[track, routeId],
			),
		},
	};
}
